/**
 * 說明 : 職位與後端調用的非同步行為
 */

// ----- import from redux toolkit -----
import {createAsyncThunk} from '@reduxjs/toolkit';

// ----- import from Base API -----
import BaseAPI from './BaseAPI';

// 新增職位
export const addPosition = createAsyncThunk(
  'position/addPosition',
  async (position, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postWithAuth(
        '/setting/position',
        position,
        token,
      );
      return data;
    } catch (err) {
      console.error('add position error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改職位
export const editPosition = createAsyncThunk(
  'position/editPosition',
  async (position, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth(
        '/setting/position',
        position,
        token,
      );
      return data;
    } catch (err) {
      console.error('edit position error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改職位狀態
export const editPositionStatus = createAsyncThunk(
  'position/editPositionStatus',
  async ({positionCode, status}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth(
        '/setting/position/status',
        {positionCode, flgStatus: status},
        token,
      );
      return data;
    } catch (err) {
      console.error('edit position error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得單筆職位資料
export const fetchPosition = createAsyncThunk(
  'position/fetchPosition',
  async (positionId, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        `/setting/position/${positionId}`,
        null,
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch position error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得職位清單列表
export const fetchPositionList = createAsyncThunk(
  'position/fetchPositionList',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/setting/position', null, token);
      return data;
    } catch (err) {
      console.error('fetch position list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得有效的職位名稱選單
export const fetchPositionSelection = createAsyncThunk(
  'position/fetchPositionSelection',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        '/selection/position',
        null,
        token,
      );
      return data;
    } catch (err) {
      console.error('fetch position selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
